import { type FC, type ReactNode } from "react";

import { AvailabilityItemWrapper } from "./AvailabilityItem.styles";

interface AvailabilityItemProps {
    text: ReactNode;
    icon: ReactNode;
}

export const AvailabilityItem: FC<AvailabilityItemProps> = ({ text, icon }) => {
    return (
        <AvailabilityItemWrapper>
            {icon}
            {text}
        </AvailabilityItemWrapper>
    );
};
